export class LoginInfo {
    token = '';
    refreshToken = '';
    expiration = '';
    companyName = '';
    facilityName = '';
    role = '';
    userName = '';
    tenantID: number;
    facilityID: number;
    companyEmail = '';
    licenseType = '';
    licenseExpired: Date;
    email = '';
    numberOfUserAllowed = 0;
    package_name :string;
    package_id:number;
    super_admin_id:number;
    package_info:any;
    Id:number;
}
